import React from 'react';
import { ExperienceEntry } from '../../types';
import { useApp } from '../../context/AppContext';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionTitle from '../ui/SectionTitle';
import TimelineItem from '../ui/TimelineItem';
import './Experience.css';

interface Props {
  experience: ExperienceEntry[];
}

const Experience: React.FC<Props> = ({ experience }) => {
  const { lang } = useApp();
  const ref = useScrollReveal();

  return (
    <section className="experience" id="experiencia">
      <div
        className="experience__inner reveal-section"
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        <SectionTitle
          eyebrow={lang === 'es' ? 'Historial profesional' : 'Professional history'}
          title={lang === 'es' ? 'Experiencia' : 'Experience'}
          number="02"
        />

        <div className="experience__timeline">
          {experience.map((entry, i) => (
            <TimelineItem key={entry.id} entry={entry} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
